export class ReportDropDownList {
    administratorReports: ReportDropDown[];
    supervisorReports: ReportDropDown[];
    fieldAgentReports: ReportDropDown[];
    companyReports: ReportDropDown[];
}

export class ReportDropDown {
    reportID: number;
    displayName: string;

    constructor() {
        this.reportID = 0;
        this.displayName = null;
    }
}

export class ReportWizardIntializePayload {
    reportID: number;

    constructor() {
        this.reportID = 0;
    }
}

export class ReportWizardCompanyPayload {
    companyID: number;

    constructor() {
        this.companyID = 0;
    }
}

export class ReportTemplateModel {
    customReportID: number;
    name: string;
    description: string;
    fileName: string;

    constructor() {
        this.customReportID = 0;
        this.name = null;
        this.description = null;
        this.fileName = null;
    }
}

export class ReportTemplatePayload {
    customReportID: number;

    constructor() {
        this.customReportID = 0;
    }
}

export class ReportWizardParameters {
    parameterID: number;
    name: string;
    caption: string;
    isRequird: boolean;
    parameterDetailsSingleSelect: boolean;
    value: string;
    previousTabs: [];
    parameterDetails: ParameterDetail[];

    constructor() {
        this.parameterID = 0;
        this.name = null;
        this.caption = null;
        this.isRequird = false;
        this.parameterDetailsSingleSelect = false;
        this.value = null;
        this.parameterDetails = new Array<ParameterDetail>();
        this.previousTabs = null;
    }
}

export class ParameterDetail {
    value: string;
    description: string;
    selected: boolean;
}

export class ParameterPaylod {
    reportParameterID: number;
    selectedValue: string;

    constructor() {
        this.reportParameterID = 0;
        this.selectedValue = null;
    }
}

export class ReportWizardDetail {
    templateName: string;
    templateDescription: string;
    fileName: string;
    fileType: string;
    saveAsTemplate: boolean;
    fileTypes: DetailFileType[];

    constructor() {
        this.templateName = null;
        this.templateDescription = null;
        this.fileName = null;
        this.fileType = null;
        this.saveAsTemplate = false;
        this.fileTypes = new Array<DetailFileType>();
    }
}

export class ReportWizardDetailPayload {
    templateName: string;
    templateDescription: string;
    fileName: string;
    fileType: string;
    saveAsTemplate: boolean;
    sendEmailOnFinish: boolean;

    constructor() {
        this.templateName = null;
        this.templateDescription = null;
        this.fileName = null;
        this.fileType = null;
        this.saveAsTemplate = false;
        this.sendEmailOnFinish = false;
    }
}

export class DetailFileType {
    exportType: string;
    description: string;

    constructor() {
        this.exportType = null;
        this.description = null;
    }
}

export class ReportSummaryPayload {
    templateName: string;
    templateDescription: string;
    fileName: string;
    fileType: string;
    saveAsTemplate: boolean;
    sendEmailOnFinish: boolean;
    summaryParameters: ReportSummaryParameter[];

    constructor() {
        this.templateName = null;
        this.templateDescription = null;
        this.fileName = null;
        this.fileType = null;
        this.saveAsTemplate = false;
        this.sendEmailOnFinish = false;
        this.summaryParameters = new Array<ReportSummaryParameter>();
    }
}

export class ReportSummaryParameter {
    caption: string;
    value: string;

    constructor() {
        this.caption = null;
        this.value = null;
    }
}

export class ReportsPayload {
    reports: Report[];

    constructor() {
        this.reports = new Array<Report>();
    }
}

/**
 * DeleteReportId is a dummy property to build out delete button for MatTable
 */
export class Report {
    reportID: number;
    status: string;
    name: string;
    category: string;
    createdDate: string;
    isFileProcessing: boolean;
    isFileCreated: boolean;
    deleteReportID: number;

    constructor() {
        this.reportID = 0;
        this.status = null;
        this.name = null;
        this.category = null;
        this.createdDate = null;
        this.isFileProcessing = false;
        this.isFileCreated = false;
        this.deleteReportID = this.reportID;
    }
}